import React, { lazy, Suspense, useEffect, useState } from "react"
import {
    TransformComponent,
    TransformWrapper,
    useControls,
} from "react-zoom-pan-pinch"
import Button from "../components/UIComponents/Button"
import MapSearchDiv from "../components/HotspotMap/MapSearchDiv"
import MapMonterDiv from "../components/HotspotMap/MapMonterDiv"

const LazyHotSpotMap = lazy(() => import("../components/HotspotMap/HotSpotMap"))

// TODO: Ska denna också vara en egen komponent? En Controls-komponent skapa även i MonterContent
const Controls = () => {
    const { zoomIn, zoomOut, resetTransform } = useControls()
    return (
        <div className=" flex justify-between gap-2 pb-2 *:flex-1 fixed bottom-safe-nav right-2 lg:right-6">
            <Button onClick={() => resetTransform()} variant={"round-button"}>
                &#8634;
            </Button>
            <Button onClick={() => zoomOut()} variant={"round-button"}>
                -
            </Button>
            <Button onClick={() => zoomIn()} variant={"round-button"}>
                +
            </Button>
        </div>
    )
}

const Map = ({ data }) => {
    const [monter, setMonter] = useState(null)
    const handleSetMonter = (item) => {
        setMonter(item)
    }
    const transformRef = React.useRef(null)

    // När vald monter ändras, zooma till montern
    useEffect(() => {
        if (transformRef.current) {
            const element = document.getElementById(monter?.monternummer)
            if (element) {
                transformRef.current.zoomToElement(element, 2.5)
            }
        }
    }, [monter])

    const clearMonter = () => setMonter(null)

    const handleUpdateMonter = (monterid) => {
        const monterToFind = data.find((d) => d.monternummer === monterid)
        if (monterToFind) setMonter(monterToFind)
    }

    return (
        <div className=" flex flex-col" data-disable-swipe>
            <div className="flex-1 flex flex-col fixed top-0 left-0 right-0 bottom-0  ">
                <div className="relative h-full w-full ">
                    <div className="z-10 fixed top-0 left-0 right-0 w-full">
                        <div className=" p-2">
                            {monter ? (
                                <MapMonterDiv
                                    item={monter}
                                    clearMonter={clearMonter}
                                />
                            ) : (
                                <MapSearchDiv
                                    data={data}
                                    handleSetMonter={handleSetMonter}
                                />
                            )}
                        </div>
                    </div>
                    <div className="absolute top-0 left-0 right-0 bottom-0 flex">
                        <TransformWrapper
                            ref={transformRef}
                            panning={true}
                            centerOnInit
                        >
                            <TransformComponent
                                contentClass="flex-1 p-4"
                                wrapperStyle={{ touchAction: "none" }}
                                wrapperClass="bg-gradient-to-br from-primary-400 to-primary-500 !h-full !w-full overflow-hidden relative"
                                contentStyle={{ width: "100%", height: "100%" }}
                            >
                                <Suspense>
                                    <LazyHotSpotMap
                                        monternummer={monter?.monternummer}
                                        handleUpdateMonter={handleUpdateMonter}
                                        interactive={true}
                                    />
                                </Suspense>
                            </TransformComponent>
                            <Controls />
                        </TransformWrapper>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Map
